<template>
  <div class="app-container">
    <navigation title="读者指南"></navigation>
    <div class="list">
      <van-cell is-link v-for="item in list" @click="go(item.id,item.title)" center>
        <template #title>
          <img v-if="item.iconPath" :src="baseUrl+item.iconPath" class="guide-list-icon">
          <span v-else></span>
          <span class="custom-title">{{ item.title }}</span>
        </template>
      </van-cell>
    </div>
    <version></version>
    <van-overlay :show="show" :lock-scroll="false">
      <div class="wrapper" @click.stop>
        <div class="prompt">
          <div class="prompt-content">
            <div class="prompt-title-tip">温馨提示：<van-icon name="close" class="close" @click="closePrompt"/></div>
            <div class="prompt-message" v-html="prompt">
            </div>
          </div>
          <div class='isPrompt'>
            <van-checkbox v-model="checked" class="checkbox" icon-size="16px">今日不再提示</van-checkbox>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tabbar, TabbarItem, NavBar, Cell, CellGroup } from 'vant'
import {request} from '../../untils/request'
import navigation from '../../components/navigation'
import version from '../../components/version'

Vue.use(Tabbar).use(TabbarItem).use(NavBar).use(Cell).use(CellGroup)

export default {
  name: 'guide',
  components: {navigation, version},
  data () {
    return {
      baseUrl: process.env.API_ROOT,
      list: [],
      show: false,
      checked: false,
      prompt: ''
    }
  },
  created () {
    // 指南列表
    this.getList()
    // 温馨提示
    this.getReminder()
    // 今日是否提示
    this.init()
  },
  methods: {
    getList () {
      var params = {
        pageNum: '1',
        pageSize: '10'
      }
      request('get', '/nlc-web/api/readerGuide', params).then(res => {
        console.log('列表', res)
        this.list = res.data.content
      })
    },
    onClickLeft () {
      this.$router.go(-1)
    },
    closePrompt () {
      this.show = false
      document.body.style.overflow = 'scroll'
      if (this.checked === true) {
        // 设置cookie值
        let date = new Date()
        date.setTime(date.getTime() + 24 * 60 * 60 * 1000)
        this.$cookies.set('guidePrompt', this.checked, date)
      }
    },
    init () {
      var guidePrompt = this.$cookies.get('guidePrompt')
      if (guidePrompt) {
        this.show = false
        document.body.style.overflow = 'scroll'
      }
    },
    needShow () {
      var guidePrompt = this.$cookies.get('guidePrompt')
      console.log(guidePrompt)
      if (guidePrompt) {
        this.show = false
        document.body.style.overflow = 'scroll'
      } else {
        this.show = true
        document.body.style.overflow = 'hidden'
      }
    },
    getReminder () {
      request('get', '/nlc-web/api/readerGuide/reminder').then(res => {
        console.log('温馨提示', res)

        if (res.data.status === 'SUCCESS') {
          if (res.data.dictValue) {
            this.prompt = this.packCrlf(res.data.dictValue)
            this.needShow()
          }
        } else {
          this.show = false
          document.body.style.overflow = 'scroll'
        }
      })
    },
    packCrlf (str) {
      var textArr = str.split(/[(\r\n)\r\n]+/)
      var html = ''
      for (var i in textArr) {
        html += textArr[i] + '<br/>'
      }
      return '<p>' + html + '</p>'
    },
    text (str, keyword) {
      var a = [] // 存。下标
      for (var k = 0; k < str.length; k++) {
        if (str.charAt(k) === keyword) {
          a.push(k)
        }
      }

      var str1 = ''// 存dom
      var texthtml = ''// 存字段
      for (var p = 0; p < a.length; p++) { // 循环字段
        if (p > 0) {
          texthtml = str.substring(a[p - 1] + 1, a[p] + 1)
        } else {
          texthtml = str.substring(0, a[p] + 1)
        }
        str1 += '<p>' + texthtml + '</p>'
      }
      return str1
    },
    go (id, title) {
      var params = {
        readerGuideId: id
      }
      request('post', '/nlc-web/api/readerGuide/info', params).then(res => {
        console.log('目录', res)
        if (res.data.childNode.length !== 0) {
          this.$router.push(
            {
              path: `/guideDirectory`,
              query: {
                id: id,
                title: title
              }
            }
          )
        } else {
          this.$router.push(
            {
              path: `/openTime`,
              query: {
                id: id,
                title: title
              }
            }
          )
        }
      })
    }
  }
}
</script>

<style scoped>
.app-container{
  background:#ecf5fd;
  overflow-y:scroll;
  min-height: calc(100% - 92px);
  position: absolute;
  top: 0px;
  bottom: 0px;
}

.list{
  width:6.94rem;
  background:#fff;
  margin:1.18rem .27rem 0 .29rem;
  border-radius:8px;
}
.van-cell{
  border-radius:8px;
}
.van-cell--clickable{
  height:1rem;
}
.wrapper{
  width: 100%;
  height: 100%;
  display:flex;
  align-items: center;
  justify-content: center;
}
.prompt{
  width: 4.9rem;
  background:#fff;
  font-size:.28rem;
  color:#47494c;
  border-radius:16px;
  padding:.34rem .3rem;
}
.prompt-title-tip{
  font-size:.36rem;
  /*color:#008095;*/
  position:relative;
  font-family: SourceHanSerifCN-SemiBold;
}
.prompt-message{
  width:96%;
  padding:0 2%;
  height:3rem;
  overflow-y:scroll;
  font-family: SourceHanSerifCN-Medium;
}
>>> .van-checkbox__label{
  line-height: .24rem;
  font-family: SourceHanSerifCN-Regular;
}
.close{
  position:absolute;
  right:.1rem;
  font-size:.36rem;
}
.isPrompt{
  width:72%;
  padding-left:28%;
  padding-top:.2rem;
}
.guide-list-icon{
  width:.28rem;
  height:.28rem;
  vertical-align: middle;
}
.van-cell::after{
  border-bottom: 1px solid #B3BBC3;
}
.custom-title{
  font-size:.28rem;
  font-family: SourceHanSerifCN-Medium;
}
</style>



// WEBPACK FOOTER //
// src/view/guide/index.vue